import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

export default function Loader() {
  const { pathname } = useLocation();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);

    const timeout = setTimeout(() => {
      setLoading(false);
    }, 500);

    return () => clearTimeout(timeout);
  }, [pathname]);

  if (!loading) return null;

  return (
      <div id="loader"><div id="gif"></div></div>
  );
}
